import { render } from "./smallCaseItem.vue?vue&type=template&id=7bd0e147&scoped=true"
import script from "./smallCaseItem.vue?vue&type=script&lang=js"
export * from "./smallCaseItem.vue?vue&type=script&lang=js"

import "./smallCaseItem.vue?vue&type=style&index=0&id=7bd0e147&scoped=true&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_ad\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd0e147"]])

export default __exports__